import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    filterList: [],
    loaded: false,
    loadingStatus: "idle",
    error: null
}

export const fetchPreventiveFilters = createAsyncThunk(
    'preventiveFilters/fetchPreventiveFilters',
    async ({token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            return await request(
                `${APP_URL}/auxiliary/survey-filters`,
                'GET',
                null,
                customHeaders
            );
        } catch (error) {
            rejectWithValue(error.status)
        }
    }
)

const preventiveFilters = createSlice({
    name: "preventiveFilters",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPreventiveFilters.pending, (state) => {
                state.filterList = [];
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchPreventiveFilters.fulfilled, (state, action) => {
                state.filterList = action.payload;
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchPreventiveFilters.rejected, (state, action) => {
                state.filterList = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default preventiveFilters.reducer;
